import * as React from 'react';

interface IProps {
    title: string;
    onMobileClose: any;
}

export const FlyoutTitle = (props : IProps) => {

    return <div className="row flyout-title">
           <div className="col">
               <button 
                onClick={ props.onMobileClose }
                className="mobile-flyout-close">
                Close
               </button>
               <h1>{ props.title }</h1>
           </div>
        </div>;
};
